export { CollectionHero } from './CollectionHero';
